import getMonthName from "./getMonthName.js"

export default function setHeadline(data, referenceDate) {

  let wounded = data.filter(d => d.homicide === "no").length
  let killed = data.filter(d => d.homicide === "yes").length
  let text = `<span class="g-highlight killed">${killed} people have been killed</span> and <span class="g-highlight wounded">${wounded}</span> were wounded by gun violence in Delaware in the past 365 days`
  let asOf = referenceDate
    ? `As of ${getMonthName(referenceDate.getMonth())}. ${referenceDate.getDate()}, ${referenceDate.getFullYear()}`
    : ''
  let el = document.querySelector(".topper__headline")
  if (el) el.innerHTML = `<div class="g-topper-as-of">${asOf}</div><div id="g-topper-wrapper">${text}</div>`
}
